import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { ResponsiveDirective } from './shared/directives/responsive.directive';

@NgModule({
  declarations: [ResponsiveDirective],
  imports: [CommonModule, LayoutModule],
  exports: [ResponsiveDirective],
})
export class ResponsiveModule {}
